export const PROJECT_STATUS = {
    NOT_STARTED: 'not_started',
    IN_PROGRESS: 'in_progress',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    COMPLETED: 'completed',
    ON_HOLD: 'on_hold',
    CANCELLED: 'cancelled',
};

export const PROJECT_PRIORITY = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
};

export const PROJECT_CATEGORY = {
    DEVELOPMENT: 'development',
    INFRASTRUCTURE: 'infrastructure',
    SECURITY: 'security',
    MIGRATION: 'migration',
    MAINTENANCE: 'maintenance',
    RESEARCH: 'research',
    OTHER: 'other',
};

export const PROJECT_CATEGORY_OPTIONS = [
    { value: PROJECT_CATEGORY.DEVELOPMENT, label: 'Development', color: '#1976d2' },
    { value: PROJECT_CATEGORY.INFRASTRUCTURE, label: 'Infrastructure', color: '#7b1fa2' },
    { value: PROJECT_CATEGORY.SECURITY, label: 'Security', color: '#d32f2f' },
    { value: PROJECT_CATEGORY.MIGRATION, label: 'Migration', color: '#ed6c02' },
    { value: PROJECT_CATEGORY.MAINTENANCE, label: 'Maintenance', color: '#2e7d32' },
    { value: PROJECT_CATEGORY.RESEARCH, label: 'Research', color: '#0288d1' },
    { value: PROJECT_CATEGORY.OTHER, label: 'Other', color: '#757575' },
];

export const PROJECT_PRIORITY_OPTIONS = [
    { value: PROJECT_PRIORITY.LOW, label: 'Low', color: 'success' },
    { value: PROJECT_PRIORITY.MEDIUM, label: 'Medium', color: 'warning' },
    { value: PROJECT_PRIORITY.HIGH, label: 'High', color: 'error' },
];

export const PROJECT_STATUS_OPTIONS = [
    { value: PROJECT_STATUS.NOT_STARTED, label: 'Not Started' },
    { value: PROJECT_STATUS.IN_PROGRESS, label: 'In Progress' },
    { value: PROJECT_STATUS.ON_HOLD, label: 'On Hold' },
];

export const PROJECT_STATUS_FILTER_OPTIONS = [
    { value: 'all', label: 'All Status' },
    { value: PROJECT_STATUS.NOT_STARTED, label: 'Not Started' },
    { value: PROJECT_STATUS.IN_PROGRESS, label: 'In Progress' },
    { value: PROJECT_STATUS.ON_HOLD, label: 'On Hold' },
    { value: PROJECT_STATUS.COMPLETED, label: 'Completed' },
];